import api from './api';

const slugify = (s = '') =>
  s.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

// Mongo docs use _id; the UI expects `id`. Normalize on the way in.
const withId = (doc) => ({ ...doc, id: doc._id || doc.id });

/** Fetch all public content together and normalize it to the UI shape. */
export async function getContent() {
  const [cats, pkgs, adds, bans] = await Promise.all([
    api.get('/categories'),
    api.get('/packages'),
    api.get('/addons'),
    api.get('/banners'),
  ]);

  const categories = cats.data.map((c) => ({ id: c.slug, name: c.name, icon: c.icon }));
  const nameToSlug = cats.data.reduce((m, c) => ({ ...m, [c.name]: c.slug }), {});

  const packages = pkgs.data.map((p) => ({
    ...withId(p),
    categoryId: p.categoryId || nameToSlug[p.category] || slugify(p.category),
  }));

  const addOns = adds.data.map(withId);
  const banners = bans.data.map(withId);

  return { categories, packages, addOns, banners };
}

/** Fetch a single package (package detail page). */
export async function getPackage(id) {
  const { data } = await api.get(`/packages/${id}`);
  return withId(data);
}

/** Add-ons only (used by detail/customize when content isn't preloaded). */
export async function getAddOns() {
  const { data } = await api.get('/addons');
  return data.map(withId);
}
